import React from 'react';
import "./about.scss";

export default function About() {
  return <div className='about' id='about'>
    <div className="left">
      <div className="hello">
        HELLO
      </div>
      <div className="world">
        WORLD
      </div>
      <div className="happyface">
        :)
      </div>
    </div>
    <div className="right">
      <div className="about-titel">
        I'M A FULL-STACK WEB DEVELOPER
      </div>
      <div className="about-titel">AN A ELECTRONIC MUSIC PRODUCER.</div>
      <div className="info">Having spent most of my life in music production and djing,
        <br></br>I think it will be interesting for me to work in the industry from a different perspective, bringing innovative ideas to help shape the future of music technology.</div>
      <div className="info">I have experience working with people from all over the world, getting their feedback and making decisions based on it.
        <br></br>I'm very good noticing people's perception and understanding what they need.
        <br></br>I love creating things that makes people happy. I always focused on pleasing the end user.</div>
      <div className="info">My goal is to integrate both together to turn my passion into my profession by working as a developer in the music industry.</div>
      <div className="info">Music and programming are both creative and technical.
        <br></br>Both requires discipline and structure, experimentation and implementation, exploration and many hours of practice.</div>


    </div>
  </div>
}
